'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helper = require('../helper');

var _helper2 = _interopRequireDefault(_helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propertyId = null; /**
                        *  加载inmobi的代码
                        * 测试网址： http://0.0.0.0:8000/?spm=1884.0.121.1&qz_gdt=1&source=inmobi&inmobi_impId=$IMP_ID&im_country=CN 
                        */


var fireEvent = function fireEvent(eventType, eventName) {
    var pingServer = 'https://advertiser.inmobiapis.cn/tpce/v1/events/' + eventType + '?trackingPartner=InMobi';
    if (window.InmobiPixel) {
        window.inmobiPixel = new window.InmobiPixel();
        window.inmobiPixel.init({
            pingServer: pingServer,
            propertyId: propertyId,
            domain: 'market.tangeche.com'
        });
    }
    window.inmobiPixel.ping(eventName, {});
};

exports.default = {
    init: function init(id) {
        propertyId = id;
        _helper2.default.loadJs('https://i.l.inmobicdn.cn/ifctpads/IFC/pixel/inmobipixel.js').then(function () {
            fireEvent('custom', 'tangeche_lp');
        });
    },
    doStatistics: function doStatistics() {
        window.inmobiPixel && fireEvent('download', 'download');
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/statistics/dist/channel/inmobi.js
// module id = Q4IM
// module chunks = 11